import ProjectIdsEnum from '../settings/ProjectIdsEnum';

export default function loadClientSettings(settings) {
    settings["project-id"] = ProjectIdsEnum.Quartarone;
    settings["language"] = "it";
    settings["website"] = "api.quartarone.uderly.it";
    // settings["api-url"] = "https://api.uderly.com/api/v1";
    settings["project-name"] = "QRT Service";
    settings["logo-dark"] = "/assets/images/quartarone/logo-light.png";
    settings["logo-light"] = "/assets/images/quartarone/logo-light.png";
    settings["mini-logo-dark"] = "/assets/images/quartarone/logo-light.png";
    settings["mini-logo-light"] = "/assets/images/quartarone/logo-light.png";

    settings["client-id"] = "2";
    //settings["client-secret"] = "znnQhFu5gMr3o9exTrX0KRhx5sBhanfALpNGCaZO";
    settings["client-secret"] = "kZJu5kEJSslIMXYkXGx4vuoEcOkcUOwMxSkHpdba";
    settings["api-url"] = "https://api.quartarone.uderly.it/api/v1";
}
